import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

/** Read-only display of a one-time generated password with a copy button. */
export function GeneratedPasswordPanel({ password }) {
  return (
    <Box sx={{ mt: 2 }}>
      <TextField
        fullWidth
        label="Generated password"
        value={password}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="copy password"
                onClick={() => navigator.clipboard?.writeText(password)}
                edge="end"
              >
                <ContentCopyIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Typography variant="caption" color="text.secondary">
        This password is shown only once — copy it now and share it with the
        user.
      </Typography>
    </Box>
  );
}
